import React from 'react';
import copilotImg from "../../../../assets/modernworkspace/copilot/copilot.png";
import '../styles/copilotSection.css';

const CopilotAdoption = () => {
    return (
        <section className="copilot-section">
            <div className="copilot-container">
                <div className="copilot-content">
                    <span className="section-badge">Microsoft 365 Copilot</span>
                    <h2 className="copilot-heading">
                        {/* AI Adoption Done Right <br /> Securely, Strategically, and Built for Business Impact */}
                        AI Adoption Done Right <br /> Securely. Strategic. and Built for Business Impact.
                    </h2>
                    <div className="copilot-description">
                        <p>
                            Microsoft 365 Copilot is transforming how organizations work, but successful adoption requires far more than just turning on a license. At Synectiks, we help businesses integrate Copilot on the right foundation: security, governance, organizational readiness, and real-world enablement. As a certified Microsoft Solutions Partner, we approach Copilot adoption as a structured transformation rather than a one-time deployment, helping organizations drive measurable productivity gains while staying secure and compliant.
                        </p>
                        
                    </div>
                </div>

                <div className="copilot-visual">
                    <img src={copilotImg} alt="Microsoft 365 Copilot Logo" className="floating-img" />
                    <div className="blob-decorator"></div>
                </div>
            </div>
        </section>
    );
};

export default CopilotAdoption;